import React from 'react'
import { Icon } from 'components/Icon/Icon'
import styles from './Menu.module.scss'
import userpickimg from 'assets/userpickimg.png'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import { formatWalletAddress } from 'layout/NavBar/helpers'
import { updateAccount, deleteAccount, cancelAuth } from 'redux/rootSlice/rootSlice'
import { MUNE_DATA } from '../UserMenu/const'
import { useNavigate } from 'react-router-dom'


type Props = {
    onOpenEditPage: () => void,
    extraContent?: any,
    onClose?: () => void
}

export function Menu(props: Props): JSX.Element {
    const { account } = useAppSelector((state) => state.root)

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    function connectMetamaskAcc() {
        const { ethereum } = window

        if (ethereum) {
            ethereum.request({ method: 'eth_requestAccounts' })
                .then((accounts: string[]) => {
                    if (accounts.length > 0) {
                        dispatch(updateAccount(accounts[0]))
                    }
                })
                .catch((error: Error) => {
                    console.error("There was an error!", error)
                })

        } else {
            console.log("Please install MetaMask!")
            props.onClose()
            alert("Please install MetaMask!")
        }
    }

    function handleDeleteAccount() {
        dispatch(deleteAccount())
    }

    function handleMetamask() {
        connectMetamaskAcc()
    }

    function logout() {
        dispatch(cancelAuth())
        navigate('/login')
    }

    return (
        <div className={styles['menu']}>
            <div className={styles['menu__header']}>
                <img className={styles['img']} src={userpickimg} alt='user' />
                <div className={styles['content']}>
                    <span className={styles['name']}>{MUNE_DATA.name}</span>
                    <span className={styles['mail']}>{MUNE_DATA.mail}</span>
                </div>
            </div>
            {props.extraContent && (
                <>
                    {props.extraContent}
                </>
            )}
            {account && (
                <div className={styles['menu__account']} onClick={() => { }}>
                    <div className={styles['menu__account__container']}>
                        <Icon name='wallet' />
                        <span>{formatWalletAddress(account)}</span>
                    </div>
                    <div className={styles['delete']} onClick={handleDeleteAccount}>
                        <Icon name='delete' />
                    </div>
                </div>
            )}
            {!account && (
                <div className={styles['menu__item']} onClick={handleMetamask}>
                    <Icon name='add' />
                    <span>Connect wallet</span>
                </div>
            )}
            <div className={styles['menu__item']} onClick={props.onOpenEditPage}>
                <Icon name='edit' />
                <span>Edit public profile</span>
            </div>
            <div className={styles['menu__logout']} onClick={logout}>
                <div className={styles['menu__item']}>
                    <Icon name='logout' />
                    <span>Log out</span>
                </div>
            </div>
        </div>
    )
}

